// rh-cta/rh-cta.js
import { createComponent } from '@lit/react';
import react from 'react';
import { RhCta } from '@rhds/elements/rh-cta/rh-cta.js';
export const Cta = createComponent({
  tagName: 'rh-cta',
  elementClass: RhCta,
  react,
  events: {},
});
